import { WorkflowTriggerTypes } from 'src/app/models/RestApiCaller/Enums/workflow-trigger-types';
import { BaseTriggerData } from './base-trigger-data';

/**
 * Représente les données d'un trigger 'Changement d'état d'une étape'.
 */
export class StepStateChangedTriggerData extends BaseTriggerData {
    /**
     * Id de l'étape.
     */
    public stepId: number = null;

    /**
     * Id de l'état qu'a pris l'étape.
     */
    public stateId: number = null;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowTriggerTypes.StepStateChanged);
    }

    /**
     * Retourne une copie d'une instance de StepStateChangedTriggerData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: StepStateChangedTriggerData) {
        if (!!other) {
            const instance = new StepStateChangedTriggerData();
            instance.stepId = other.stepId;
            instance.stateId = other.stateId;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
